module.exports = __webpack_public_path__ + "img/flt_pt_square_bolt.prt.7a399978.jpg";